var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.61 10.742a4.177 4.177 0 100-8.354 4.177 4.177 0 000 8.354zM10.61 11.622a6.603 6.603 0 00-6.595 6.595.44.44 0 00.44.44h12.311a.44.44 0 00.44-.44 6.603 6.603 0 00-6.596-6.595z",
    fill: "#fff"
  })));
}
export default SvgSvgUser;